import axios from '@/libs/http'
import http from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 获取余额
 */
export const getBalance = () => {
  return axios.request({
    url: '/s/balance/getBalance',
    params: {
    },
    method: 'post'
  })
}

export const recharge = (amount,payMethod) => {
  return http({
    url: '/s/balance/recharge',
    params: {
      amount,payMethod
    },
    method: 'post'
  })
}


/**
 * 提现
 */
export const withdraw = (role,amount, realName, screenshot) => {
  let data = new URLSearchParams()
  appendIfNotEmpty(data,"role", role)
  data.append("amount", amount)
  data.append("realName", realName)
  data.append("screenshot", screenshot)
  return axios.request({
    url: '/s/balance/withdraw',
    data,
    method: 'post'
  })
}
/**
 * 提现
 */
export const listBalanceDetail = (role,createdStart,createdEnd,pageNo,pageSize) => {
  return axios.request({
    url: '/s/balance/listBalanceDetail',
    params: { role,createdStart,createdEnd,pageNo, pageSize},
    method: 'post'
  })
}

